import { render } from "./ResetPassword.vue?vue&type=template&id=8d2077e8&scoped=true&ts=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=8d2077e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d2077e8"]])

export default __exports__